var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.971191,
    width: 30,
    height: 30,
    rx: 8,
    fill: "black",
    fillOpacity: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3367 20.8165L12.9516 20.7532C11.8555 20.7312 10.7568 20.7752 9.68222 20.5468C8.04758 20.2055 7.93178 18.5323 7.8106 17.1287C7.64364 15.1555 7.70827 13.1465 8.02337 11.1898C8.20125 10.0919 8.90127 9.43671 9.98384 9.36542C13.6383 9.10669 17.3171 9.13735 20.9634 9.25806C21.3485 9.26912 21.7363 9.3296 22.116 9.39844C23.9904 9.73421 24.0361 11.6304 24.1576 13.2266C24.2788 14.8393 24.2277 16.4602 23.996 18.0619C23.8102 19.3881 23.4547 20.5002 21.9544 20.6076C20.0746 20.748 18.2379 20.861 16.3529 20.825C16.3529 20.8165 16.3421 20.8165 16.3367 20.8165ZM14.3466 17.459C15.7632 16.6278 17.1527 15.8105 18.5612 14.9849C17.142 14.1537 15.7551 13.3364 14.3466 12.5108V17.459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic_youtube.89dcc289.svg";
export { ForwardRef as ReactComponent };